import ShareReportConfigApi from './_shareReportConfigApi';
import httpClient from '@/apis/base/httpclient';

class ShareReportFormulaAPI extends ShareReportConfigApi {
  constructor() {
    super();
  }
  controllerName = 'ShareReportFormulas';


}

export default new ShareReportFormulaAPI();
